<template>
  <header class="header text-center">
    <div class="container-fluid">
      <a href="/" class="btn back-button">Back</a>
      <img src="../assets/images/profile/h1.png" class="img-fluid logo-deco"/>
      <a href="/" class="">
        <img src="../assets/images/profile/h2.png" class="img-fluid logo"/>
      </a>
    </div>

    <div class="profile-cards">
      <div class="container-lg">
        <div class="row text-start">
          <div class="col-lg-4 color-light p-0">
            <div class="card1 p-4 header-card" id="hover1">
              <div>
                <div class="card-title">Products</div>
                <hr class="card-line d-none d-lg-block"/>
              </div>
              <div class="card-inner" style="visibility: visible; opacity: 1;" id="show1">
                <div class="card-text">Art & Stationary</div>
                <div class="card-text">Science & Robotics Labs</div>
                <div class="card-text">GVTRONICS – Electronics E-Store</div>
                <div class="card-text">
                  GVMUSIC – Musical Instruments E-Store
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 color-light p-0">
            <div class="card2 p-4 header-card" id="hover2">
              <div>
                <div class="card-title">Education</div>
                <hr class="card-line d-none d-lg-block"/>
              </div>
              <div class="card-inner" style="visibility: visible; opacity: 1;" id="show2">
                <div class="card-text">
                  Physical & Virtual Training<br/>
                  and Skill Development
                </div>
                <div class="card-text">
                  Educational Content Production <br/>and Evaluation
                </div>
                <div class="card-text">
                  Educational Business<br/>
                  Consultation
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 color-light p-0">
            <div class="card3 p-4 header-card" id="hover3">
              <div>
                <div class="card-title">Technologies</div>
                <hr class="card-line d-none d-lg-block"/>
              </div>
              <div class="card-inner" style="visibility: visible; opacity: 1;" id="show3">
                <div class="card-text">Platform Development</div>
                <div class="card-text">Experiential Events</div>
                <div class="card-text">AI & Electronics Projects</div>
                <div class="card-text">and Project Consultation</div>
                <div class="card-text">Media and Production</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container our-values">
      <div class="title text-end">WE VALUE</div>
      <div class="values">
        <div class="value">Social <br/>Responsibility</div>
        <div class="value">
          Creativity<br/>
          and Excellence
        </div>
        <div class="value text-secondary">
          Sustainable<br/>
          Development
        </div>
        <div class="value">
          Unlimited<br/>
          Learning
        </div>
        <div class="value">
          Ability<br/>
          To Succeed
        </div>
        <div class="value">
          Integrity<br/>
          and Respect
        </div>
        <div class="value">Teamwork</div>
      </div>
    </div>
  </header>

  <section class="trust mb-5">
    <div class="container">
      <div class="trust-title mb-5">Some of the names that trust us</div>
      <div class="row align-items-center justify-content-between pb-5">
        <div class="col-lg-6 mb-5">
          <img
              src="../assets/images/profile/companies.png"
              alt="companies"
              class="img-fluid"
          />
        </div>
        <div class="col-lg-6 d-flex align-self-center justify-content-center">
          <div class="trust-card d-flex flex-column p-4">
            <img
                alt="deco"
                src="../assets/images/profile/marks.png"
                class="marks-top align-self-start img-fluid"
            />
            <div class="trust-text color-light my-2 align-self-center p-3">
              Our big ideas started with human insight & ended with briliant
              execution.
            </div>
            <img
                alt="deco"
                src="../assets/images/profile/marks.png"
                class="marks-bottom align-self-end img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="harmony">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-xl-4 offset-xl-1 col-xs-12">
          <div class="section-title-harmony color-light mb-5">
            OUR IN-HOUSE <br> CAPABILITIES <br> COMBINED WITH <br> TRUSTED PARTNERS <br> ENABLE US TO
            PROVIDE
            <br> YOU WITH A <br> HARMONIOUS SOLUTION
          </div>
          <div class="section-title-line"></div>
        </div>
        <div class="col-xl-5 col-xs-12 offset-xl-1 d-flex flex-column">
          <div class="d-flex align-items-center justify-content-between mb-5">
            <div class="circle blue color-light">
              <div class="wave" style="background-color: blue;"></div>
              <div class="wave-text">
                Quick turn<br/>
                around
              </div>
            </div>
            <div class="circle red color-light text-center">
              <div class="wave"></div>
              <div class="wave-text">
                Seamless<br/>
                Execution
              </div>
            </div>
            <div class="circle green color-light">
              <div class="wave" style="background-color: green;"></div>
              <div class="wave-text">
                Flexibility
              </div>
            </div>
          </div>
          <img src="../assets/images/profile/harmony.png" alt="graph"
               class="img-fluid align-self-center"/>
        </div>
      </div>
    </div>
  </section>

  <section class="gv-group py-5">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-xl-3">
          <div class="group-title color-dark mb-5">Global Vision Group</div>
          <div class="section-title-linedark"></div>
        </div>
        <div class="col-xl-9">
          <div class="row">
            <div class="col-lg-3 group-card card1">
              <div class="card-number">01.</div>
              <div class="card-text color-light">
                Global Vision Traning & Eduation Consultancy
              </div>
            </div>
            <div class="col-lg-3 group-card card2">
              <div class="card-number">02.</div>
              <div class="card-text color-light">
                Global Vision Event Management
              </div>
            </div>
            <div class="col-lg-3 group-card card3">
              <div class="card-number">03.</div>
              <div class="card-text color-light">Robocup</div>
            </div>
            <div class="col-lg-3 group-card card4">
              <div class="card-number">04.</div>
              <div class="card-text color-light">Global Arts Academy</div>
            </div>
            <div class="col-lg-3 group-card card5">
              <div class="card-number">05.</div>
              <div class="card-text color-light">Global Music Academy</div>
            </div>
            <div class="col-lg-3 group-card card6">
              <div class="card-number">06.</div>
              <div class="card-text color-light">Mathnasium</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="what-we-do">
    <div class="container">
      <div class="title mb-5 pt-5">What We Do</div>
      <div class="row">
        <img alt="line" src="../assets/images/profile/line-xl.png"/>
        <div class="col-lg-3 offer">
          <div class="offer-text">01.</div>
          <div class="offer-text">Training & Professional Development</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">02.</div>
          <div class="offer-text">Education Business Consultation</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">03.</div>
          <div class="offer-text">Educational Content Production</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">04.</div>
          <div class="offer-text">Skills Academy</div>
        </div>
        <img
            alt="line"
            src="../assets/images/profile/line-xl.png"
            class="d-none d-xl-block"
        />
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">05.</div>
          <div class="offer-text">Assessment & Evaluation</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">06.</div>
          <div class="offer-text">Strategic Consultancy</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">07.</div>
          <div class="offer-text">Recruitment & Qualification</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">08.</div>
          <div class="offer-text">Web & App Development</div>
        </div>
        <img
            alt="line"
            src="../assets/images/profile/line-xl.png"
            class="d-none d-xl-block"
        />
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text d-none d-xl-block">09.</div>
          <div class="offer-text">Local & International Events</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">10.</div>
          <div class="offer-text">Events Logistics Managment</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">11.</div>
          <div class="offer-text">Branding & Design</div>
        </div>
        <div class="col-lg-3 offer d-none d-xl-block">
          <div class="offer-text">12.</div>
          <div class="offer-text">Media Planning & Buying</div>
        </div>
      </div>
      <div class="circles pb-5 d-xl-none">
        <div class="circle-sm me-1"></div>
        <div class="circle-md me-1"></div>
        <div class="circle-lg me-1"></div>
        <div class="circle-md me-1"></div>
        <div class="circle-sm"></div>
      </div>
    </div>
  </section>

  <section class="history mb-5">
    <div class="container-lg my-5">
      <h2 class="title">Our History</h2>
      <h3 class="sub-title">Successful Stories</h3>
      <div class="d-flex align-items-center">
        <div class="history-point-first">
          <div class="point"></div>
        </div>
        <img alt="logo" src="../assets/images/profile/moe.png" class="brand-logo"/>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row history1 align-items-center">
        <div class="col-xl-6 p-0">
          <img
              alt="ia"
              src="../assets/images/profile/history1.png"
              class="img-fluid"
          />
        </div>
        <div class="col-xl-6">
          <h2 class="inner-title">
            CLIENT: Ministry of Education
            <br>PROJECT: Artificial intelligence and robotics national competition 2021
          </h2>
          <p class="inner-text">
            The Artificial Intelligence and Robot Competition series is an
            educational event that consists of 28 categories within these
            national and global championships: VEX Robot Championship, ROV
            Submarine Championship, FIRST Robot Championship, FIRST Robot
            Championship, Robocop Jr Robot Championship, HGP Motor
            Championship, FWT Aircraft Championship, Creative Innovation
            Championship, and Mini-Programmer’s championship.
          </p>
          <p class="inner-text">
            The Virtual National Championship Series of Artificial
            Intelligence and Robotics Competitions 2021 was one of the biggest
            educational virtual events of the year, with over 1,789
            Participants and 910 teams competing in 32 competitions. The event
            was running on air-series.ae, an in-house developed platform where
            trainings, and competitions and live streaming was held.
          </p>
        </div>
      </div>

      <div class="container-lg my-5">
        <div class="d-flex align-items-center justify-content-between">
          <div class="history-point-second">
            <div class="point"></div>
          </div>
          <img
              alt="logo"
              src="../assets/images/profile/actvet.png"
              class="brand-logo"
              style="right: 60px; position: absolute;"
          />
        </div>
      </div>
      <div class="container-lg me-5">
        <div class="row history2 mb-5 align-items-center">
          <div class="col-xl-6">
            <h2 class="inner-title">
              CLIENT: ACTVET
              <br>PROJECT: Emirates Skills 2021 & 2022
            </h2>
            <p class="inner-text">
              The annual Emirates Skills Competition attracts UAE Nationals, both young men and women, to compete in the
              field of craftsmanship and technology and be evaluated by a technical committee and internationally
              accredited experts based on the standards and judging criteria of WorldSkills organization. Under the
              patronage of Her Highness Sheikha Fatima Bint Mubarak, Chairwoman of the General Women’s Union, Supreme
              Chairwoman of the Family Development Foundation and President of the Supreme Council for Motherhood and
              Childhood, EmiratesSkills promotes the annual National Competition.
            </p>
            <p class="inner-text">
              The Emirates Skills event is an educational event that celebrates the outstanding Emirati talents in more
              than 30 technical and vocational skills categories across 40 competitions, competitors of the 2022 event
              have participated in six skills areas: construction and building technology; manufacturing and engineering
              technology; transportation and logistics; creative arts and fashion; information and communication
              technology; and social and personal services, and holding 17 engineering and technical fields in the 2021
              event.
            </p>
            <p class="inner-text">
              Organized by the ACTVET, the Emirates Skills 2021 and 2022 continued for Four days at the Abu Dhabi
              National Exhibition Centre halls. The event had over 700 participants, Live Streamed to over 1.1K views
              and some honourable VIP visits from H.H. Sheikh Khaled bin Mohamed bin Zayed Al Nahyan, member of the Abu
              Dhabi Executive Council and Chairman of the Abu Dhabi Executive Office, Sheikh Nahyan bin Mubarak Al
              Nahyan, heads the United Arab Emirates Ministry of Culture, Youth, and Social Development, Mohammed bin
              Ahmed Al Bowardi, Minister of State for Defence Affairs, and Hussain bin Ibrahim Al Hammadi, Minister of
              Education.
            </p>
          </div>
          <div
              class="col-xl-6 mb-5 history-img order-first order-lg-last d-flex justify-content-xl-end justify-content-lg-center">
            <div style="display:inline-block; position: relative;">
              <button class="btn text-white btn-chevron" @click.prevent="showPrev(1)"
                      style="position: absolute;left: -8%; top: 43%;">
                <i class="fa fa-chevron-left fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
              <div id="batch1">
                <img alt="history2" src="../assets/images/profile/batch1/one.png"
                     class="img-fluid show"/>
                <img alt="history2" src="../assets/images/profile/batch1/two.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch1/three.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch1/four.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch1/five.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch1/six.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch1/seven.png"
                     class="img-fluid hide"/>
              </div>
              <button class="btn text-white btn-chevron" @click.prevent="showNext(1)"
                      style="position: absolute;right: -8%; top: 43%;">
                <i class="fa fa-chevron-right fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="container-lg my-5">
        <div class="d-flex align-items-center">
          <div class="history-point-third">
            <div class="point"></div>
          </div>
          <img alt="logo" src="../assets/images/profile/moe.png" class="brand-logo"/>
        </div>
      </div>
      <div class="container-lg me-5">
        <div class="row history3 mb-5 align-items-center">
          <div class="col-xl-6 mb-5 d-flex justify-content-xl-start justify-content-lg-center">
            <div style="display:inline-block; position: relative;">
              <button class="btn text-white btn-chevron" @click.prevent="showPrev(2)"
                      style="position: absolute;left: -8%; top: 43%;">
                <i class="fa fa-chevron-left fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
              <div id="batch2">
                <img alt="history2" src="../assets/images/profile/batch2/one.png"
                     class="img-fluid show"/>
                <img alt="history2" src="../assets/images/profile/batch2/two.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch2/three.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch2/four.png"
                     class="img-fluid hide"/>
              </div>
              <button class="btn text-white btn-chevron" @click.prevent="showNext(2)"
                      style="position: absolute;right: -8%; top: 43%;">
                <i class="fa fa-chevron-right fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-xl-6">
            <h2 class="inner-title">
              CLIENT: Ministry of Education
              <br>PROJECT: Artificial intelligence and robotics national competition 2020
            </h2>
            <p class="inner-text">
              The Artificial Intelligence and Robot Competition series is an
              educational event that consists of 28 categories within these
              national and global championships: VEX Robot Championship, ROV
              Submarine Championship, FIRST Robot Championship, FIRST Robot
              Championship, Robocop Jr Robot Championship, HGP Motor
              Championship, FWT Aircraft Championship, Creative Innovation
              Championship, and Mini-Programmer’s championship.
            </p>
            <p class="inner-text">
              The National Championship of Series of Artificial Intelligence
              and Robotics Competitions was held at ADNEC halls 9,10,11 and
              ICCC, with over 2,000 Participants, around 3,000 visitors per
              day throughout the competition days, and a prestigious number of
              honourable VIP visits, opening the event H.H. Sheikh Khalid bin
              Mohamed bin Zayed Al Nahyan, Chairman of Abu Dhabi Executive
              Office, opening speech of Hussain bin Ibrahim Al Hammadi,
              Minister of Education, and many more.
            </p>
          </div>
        </div>
      </div>
      <div class="container-lg my-5">
        <div class="d-flex align-items-center justify-content-between">
          <div class="history-point-fourth">
            <div class="point"></div>
          </div>
          <img
              alt="logo"
              src="../assets/images/profile/tdra.png"
              class="brand-logo"
              style="right: 60px; position: absolute;"
          />
        </div>
      </div>
      <div class="container-lg me-5">
        <div
            class="row history4 mb-5 align-items-center justify-content-between"
        >
          <div class="col-xl-6">
            <h2 class="inner-title">
              CLIENT: TDRA
              <br>PROJECT: Virtual Innovation Camp 2020
            </h2>
            <p class="inner-text">
              The Innovation Camps are summer and winter camps organised by
              TDRA. Throughout the camp, the participants will experience the
              steps of an intense innovation process in the fields of Robotics
              and Electronics.
            </p>
            <p class="inner-text">
              Participants of ages 4 – 18 all go through virtual training of
              daily live sessions and recorded materials to enable them to
              build the camp project of their chosen path. From camp
              logistics, educational programs to live support, Global Vision
              will lead you every step of the way. WSIS award for the best
              camp April 2019 from Switzerland Geneva.
            </p>
            <p class="inner-text">
              Participants of ages 4 – 18 all go through virtual training of
              daily live sessions and recorded materials to enable them to
              build the camp project of their chosen path.
            </p>
            <p class="inner-text">
              From camp logistics, educational programs to live support,
              Global Vision will lead you every step of the way.
            </p>
            <p class="inner-text fw-bold">
              WSIS award for the best camp April 2019 from Switzerland Geneva.
            </p>
          </div>
          <div class="col-xl-6 p-0 order-first order-lg-last">
            <img
                alt="history2"
                src="../assets/images/profile/history4.png"
                class="img-fluid"
            />
          </div>
        </div>
      </div>
      <div class="container-lg my-5">
        <div class="d-flex align-items-center" style="margin-right: 30%;">
          <div class="history-point-third">
            <div class="point"></div>
          </div>
          <img alt="logo" src="../assets/images/profile/ws.png" class="brand-logo"/>
        </div>
      </div>
      <div class="container-lg me-5">
        <div class="row history5 mb-5 align-items-center">
          <div class="col-xl-6 mb-5 d-flex justify-content-xl-start justify-content-lg-center">
            <div style="display:inline-block; position: relative;">
              <button class="btn text-white btn-chevron" @click.prevent="showPrev(3)"
                      style="position: absolute;left: -8%; top: 43%;">
                <i class="fa fa-chevron-left fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
              <div id="batch3">
                <img alt="history2" src="../assets/images/profile/batch3/one.png"
                     class="img-fluid show"/>
                <img alt="history2" src="../assets/images/profile/batch3/two.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch3/three.png"
                     class="img-fluid hide"/>
                <img alt="history2" src="../assets/images/profile/batch3/four.png"
                     class="img-fluid hide"/>
              </div>
              <button class="btn text-white btn-chevron" @click.prevent="showNext(3)"
                      style="position: absolute;right: -8%; top: 43%;">
                <i class="fa fa-chevron-right fa-1x rounded-circle" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="col-xl-6">
            <h2 class="inner-title">PROJECT: WorldSkills 2018 - 2021</h2>
            <p class="inner-text">
              WorldSkills builds confidence, empowers communities, and helps
              to fuel economies. With that in mind GVC has been training UAE
              Junior teams for the local and international skills
              competitions. Here’s a glimpse of our hero’s achievements…
            </p>
            <div class="row medals">
              <div class="col-xl-6 col-md-12">
                <div class="number">08</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">WorldSkills Asia 2021</div>
                    <div class="number-medals">8 Medals</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12">
                <div class="number">27</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">WorldSkills Asia 2019</div>
                    <div class="number-medals">27 Medals</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12">
                <div class="number">03</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">RussiaSkills 2021</div>
                    <div class="number-medals">3 Medals</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12">
                <div class="number">15</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">Emirates Skills 2019</div>
                    <div class="number-medals">15 Medals</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12">
                <div class="number">04</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">WorldSkills KAZAN 2019</div>
                    <div class="number-medals">4 Medals</div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-md-12">
                <div class="number">15</div>
                <div class="event d-flex align-items-center">
                  <div class="medals-point"></div>
                  <div>
                    <div class="event-name">Emirates Skills 2018</div>
                    <div class="number-medals">15 Medals</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="history-footer text-center" style="margin-bottom: 5rem;">
      <div class="history-point-last">
        <div class="point"></div>
      </div>
      <h2 class="color-dark last-text">Our Story has just begun</h2>
    </div>
  </section>

  <footer class="footer color-light" style="padding-top: 8rem;">
    <h2 class="title mb-2">Our business is your business</h2>
    <h3 class="sub-title">Enough about us, let’s talk You!</h3>
    <img
        alt="logo"
        src="../assets/images/profile/footer-logo.png"
        class="footer-logo img-fluid px-5"
    />
    <h3 class="sub-title mb-5">info@gvc.ae | www.gvc.ae</h3>
    <div class="d-flex">
      <i class="fa fa-facebook fa-2x me-3" aria-hidden="true"></i>
      <i class="fa fa-instagram fa-2x me-3" aria-hidden="true"></i>
      <i class="fa fa-twitter fa-2x" aria-hidden="true"></i>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GVLearning',
  methods: {
    showNext(id) {
      let batch = document.getElementById(`batch${id}`)
      let images = batch.children
      let found = false;
      let first = true;
      for (let i = 0; i < images.length; i++) {
        let classes = images[i].classList;
        if (found === false && i === images.length - 1) {
          images[i].classList.replace('show', 'hide');
          images[0].classList.replace('hide', 'show');
          return;
        }
        if (classes.contains('hide') && found === true && first === true) {
          images[i].classList.replace('hide', 'show');
          first = false;
        }
        if (classes.contains('show') && found === false) {
          images[i].classList.replace('show', 'hide');
          found = true;
        }
      }
    },
    showPrev(id) {
      let batch = document.getElementById(`batch${id}`)
      let images = batch.children
      let found = false;
      let first = true;
      for (let i = images.length - 1; i >= 0; i--) {
        if (found === false && i === 0) {
          images[i].classList.replace('show', 'hide');
          images[images.length - 1].classList.replace('hide', 'show');
          return;
        }
        let classes = images[i].classList;
        if (classes.contains('hide') && found === true && first === true) {
          images[i].classList.replace('hide', 'show');
          first = false;
        }
        if (classes.contains('show') && found === false) {
          images[i].classList.replace('show', 'hide');
          found = true;
        }
      }
    }
  }
}
</script>

<style>
@import '../assets/styles/profile.css';

@media (min-width: 1518px) and (max-width: 1700px) {
  .history .last-text {
    margin-top: 800px;
  }
}

@media (min-width: 1700px) and (max-width: 1950px) {
  .history .last-text {
    margin-top: 750px;
  }
}

@media (min-width: 1950px) {
  .history .last-text {
    margin-top: 600px;
  }
}
</style>
